export const CHECKOUT_URL =
  'https://profesor-tecnico-en-arduino-y-robotica.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/foDGMfMM35JwxB5U5Ljcwr/Imagen_de_ChatGPT_5_oct_2026,_16_18_37.png'

export const PRODUCT_NAME = 'MEGA PACK PROFESOR TÉCNICO EN ARDUINO Y ROBÓTICA'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'layers' as const,
    title: 'MATERIAL DISPERSO',
    desc: 'Guardas actividades, códigos, circuitos, videos y proyectos de diferentes lugares, pero tienes que perder horas ordenando todo antes de llevarlo al aula.',
  },
  {
    icon: 'question' as const,
    title: 'NO SABES QUÉ ENSEÑAR PRIMERO',
    desc: 'Arduino, programación, sensores, motores, automatización, robótica... hay tantos contenidos posibles que organizar una secuencia completa puede resultar complicado.',
  },
  {
    icon: 'clipboard' as const,
    title: 'TE FALTA MATERIAL PRÁCTICO',
    desc: 'Quieres que tus alumnos aprendan haciendo, pero necesitas actividades, evaluaciones, diagramas y proyectos que puedas utilizar durante las clases.',
  },
  {
    icon: 'refresh' as const,
    title: 'SIGUES PREPARANDO TODO DESDE CERO',
    desc: 'Cada nueva clase significa volver a buscar ejercicios, diseñar actividades y pensar proyectos en lugar de trabajar sobre una estructura organizada.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    icon: 'cpu' as const,
    title: 'FUNDAMENTOS DE ARDUINO Y ELECTRÓNICA APLICADA',
    desc: 'Comprende Arduino UNO, entradas y salidas, tensión, corriente, resistencia, componentes electrónicos, protoboard, multímetro, Arduino IDE y las primeras prácticas con circuitos.',
  },
  {
    icon: 'code' as const,
    title: 'PROGRAMACIÓN DE ARDUINO DESDE CERO',
    desc: 'Trabaja variables, entradas y salidas digitales, condiciones, operadores, bucles, funciones, entradas analógicas, PWM, temporización, Monitor Serie y ejercicios de programación.',
  },
  {
    icon: 'radio' as const,
    title: 'SENSORES, ACTUADORES Y SISTEMAS DE MEDICIÓN',
    desc: 'Aprende a trabajar con LDR, temperatura, humedad, ultrasonido, PIR, infrarrojos, buzzer, relés, servomotores y displays mediante actividades prácticas.',
  },
  {
    icon: 'cog' as const,
    title: 'MOTORES Y FUNDAMENTOS DE ROBÓTICA',
    desc: 'Comprende motores DC, drivers, puente H, L298N, PWM, servomotores, motores paso a paso, vehículos robóticos, seguimiento de línea y detección de obstáculos.',
  },
  {
    icon: 'bulb' as const,
    title: 'AUTOMATIZACIÓN CON ARDUINO Y PROYECTOS INTELIGENTES',
    desc: 'Desarrolla sistemas automáticos utilizando sensores, umbrales, actuadores, temporización y estados mediante proyectos como iluminación, riego, alarmas, barreras y estacionamientos.',
  },
  {
    icon: 'bot' as const,
    title: 'ROBÓTICA APLICADA Y PROYECTOS INTEGRADORES PARA EL AULA',
    desc: 'Integra electrónica, programación, sensores y motores mediante robots evita obstáculos, seguidores de línea, brazos robóticos, casas inteligentes, invernaderos y proyectos finales para el aula.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    icon: 'activity' as const,
    title: '100 ACTIVIDADES PRÁCTICAS DE ARDUINO Y ROBÓTICA™',
    desc: 'Un banco de 100 actividades organizadas desde electrónica y programación básica hasta sensores, motores, automatización y robótica para utilizar en clases, talleres y trabajos prácticos.',
    value: 'Valor: $7.990',
  },
  {
    icon: 'check' as const,
    title: '50 EVALUACIONES + RESPUESTAS PARA EL DOCENTE™',
    desc: '50 consignas sobre Arduino, electrónica, programación, sensores, motores, automatización y robótica, acompañadas por una guía de respuestas para facilitar la evaluación y corrección.',
    value: 'Valor: $5.990',
  },
  {
    icon: 'calendar' as const,
    title: 'PLANIFICACIONES DE CLASE EDITABLES™',
    desc: 'Planificaciones organizadas con objetivos, contenidos, materiales, actividades prácticas y criterios de evaluación para enseñar Arduino y Robótica siguiendo una secuencia progresiva.',
    value: 'Valor: $6.990',
  },
  {
    icon: 'network' as const,
    title: 'DIAGRAMAS Y CIRCUITOS LISTOS PARA IMPRIMIR™',
    desc: 'Una colección visual de diagramas, circuitos y fichas sobre Arduino, sensores, motores, drivers, servomotores, automatización y robótica para utilizar directamente durante las clases.',
    value: 'Valor: $8.990',
  },
  {
    icon: 'bot' as const,
    title: '30 PROYECTOS DE ARDUINO Y ROBÓTICA PARA EL AULA™',
    desc: '30 proyectos organizados por dificultad para trabajar electrónica, sensores, automatización, vehículos robóticos, brazos, casas inteligentes, invernaderos y proyectos integradores.',
    value: 'Valor: $9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'clock' as const,
    title: 'MENOS HORAS PREPARANDO MATERIAL',
    desc: 'Deja de buscar actividades, circuitos y proyectos por diferentes lugares y trabaja siguiendo una ruta organizada.',
  },
  {
    icon: 'wrench' as const,
    title: 'MÁS CLASES PRÁCTICAS',
    desc: 'Utiliza actividades, sensores, circuitos, evaluaciones y proyectos para que los alumnos aprendan Arduino y Robótica mediante la práctica.',
  },
  {
    icon: 'route' as const,
    title: 'UNA RUTA CLARA PARA ENSEÑAR',
    desc: 'Avanza desde los fundamentos de electrónica y programación hasta automatización y robótica siguiendo contenidos progresivos.',
  },
  {
    icon: 'package' as const,
    title: 'MATERIAL LISTO PARA EL AULA',
    desc: 'Dispón de planificaciones, evaluaciones, actividades, diagramas y proyectos que puedes adaptar según tus alumnos y recursos disponibles.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Daba algunas prácticas de Arduino, pero cada clase terminaba buscando actividades nuevas por diferentes lugares. Tener los contenidos y ejercicios organizados me ayudó a preparar las clases con mucho más orden.',
    author: 'Martín Fernández',
    role: 'Profesor técnico, 38 años',
    location: 'Buenos Aires, Argentina',
  },
  {
    quote:
      'Lo que más me sirvió fueron las actividades y proyectos. Puedo elegir el contenido que estoy trabajando y encontrar una práctica relacionada sin tener que empezar todo desde cero.',
    author: 'Carlos Ibáñez',
    role: 'Docente de electrónica, 44 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Enseñaba electrónica, pero quería incorporar Arduino y robótica de una forma más organizada. Los tomos me ayudaron a conectar programación, sensores y motores dentro de una misma secuencia.',
    author: 'Laura Quiroga',
    role: 'Profesora técnica, 36 años',
    location: 'Montevideo, Uruguay',
  },
  {
    quote:
      'Las evaluaciones y planificaciones me resultaron muy prácticas. Antes preparaba cada actividad por separado y ahora tengo material que puedo adaptar según el curso.',
    author: 'Cristian Molina',
    role: 'Docente técnico, 40 años',
    location: 'Santiago, Chile',
  },
  {
    quote:
      'Buscaba proyectos para que los alumnos hicieran más prácticas. El banco de actividades y los proyectos me dieron muchas ideas para trabajar durante el año.',
    author: 'Héctor Ramírez',
    role: 'Profesor de electrónica, 47 años',
    location: 'Guadalajara, México',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos avanzados?',
    a: 'No. El material comienza desde los fundamentos y avanza progresivamente hacia programación, sensores, automatización y robótica.',
  },
  {
    q: '¿Qué voy a encontrar?',
    a: '6 tomos organizados sobre Arduino, programación, sensores, motores, automatización y robótica aplicada.',
  },
  {
    q: '¿Incluye actividades prácticas?',
    a: 'Sí. Incluye actividades, evaluaciones, planificaciones, diagramas y proyectos para complementar los contenidos.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos con la compra.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizas un único pago y obtienes acceso al material incluido.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Al tratarse de material digital, el acceso se realiza de forma digital después de la compra.',
  },
  {
    q: '¿Esto reemplaza una formación o certificación oficial?',
    a: 'No. Es material educativo de apoyo y no reemplaza títulos, certificaciones ni formación oficial.',
  },
  {
    q: '¿Puedo utilizarlo a mi ritmo?',
    a: 'Sí. Puedes avanzar y adaptar los contenidos según tus necesidades y las de tus clases.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes comunicarte mediante nuestro canal de soporte.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Gustavo Pereyra', city: 'Córdoba', minutes: 3 },
  { name: 'Silvina Acosta', city: 'Rosario', minutes: 6 },
  { name: 'Ricardo Benítez', city: 'Buenos Aires', minutes: 9 },
  { name: 'Mariana Ortiz', city: 'Mendoza', minutes: 13 },
  { name: 'Fernando Luna', city: 'La Plata', minutes: 17 },
  { name: 'Claudia Romero', city: 'Mar del Plata', minutes: 21 },
  { name: 'Diego Cabrera', city: 'Salta', minutes: 26 },
  { name: 'Alejandro Díaz', city: 'San Miguel de Tucumán', minutes: 31 },
]
